export class EnaioDocumentsConfig {
    onlyEmbedded = false;
}
